import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SyncService } from './services/sync.service';
import { SynchronizationEventService } from './services/synchronization-event.service';
import { SyncServiceStatusComponent } from './components/sync-service-status/sync-service-status.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        SyncServiceStatusComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
    ],
    exports: [
        SyncServiceStatusComponent
    ],
    providers: [
        SyncService,
        SynchronizationEventService
    ]
})
export class SynchronizationModule { }
